var title = 'fx_2d2fb1e5_nqd5t80';

export { title };
//# sourceMappingURL=title.vanilla.mjs.map
